var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { LookupValueRequest, OrderByEnum } from "../../../../models/lookups/lookup.models";
import { LookupValueQuery } from "../../../../models/lookups/lookup.models";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { QueriesClientService } from "../../../../services/queries/queries-client.services";
import { BrandClientService } from "../../../../services/modules/brand-client.service";
import { OperatorClientService } from "../../../../services/modules/operator-client.service";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { TokenClient } from "../../../../services/authentication/token-client.service";
import { UserClaimsService } from "../../../../services/authentication/user-claims.service";
import { LotteryPlatformClaims } from "../../../../constants/modules/lotteryplatform.claims";
import { UnitOfWorkAction } from "../../../../utilities/unit-of-work-observer";
import { I18N } from "aurelia-i18n";
var TopupPage = /** @class */ (function () {
    function TopupPage(notificationService, i18N, lookupService, queriesClientService, brandClientService, operatorClientService, tokenClient, userClaimsService) {
        this.notificationService = notificationService;
        this.i18N = i18N;
        this.lookupService = lookupService;
        this.queriesClientService = queriesClientService;
        this.brandClientService = brandClientService;
        this.operatorClientService = operatorClientService;
        this.tokenClient = tokenClient;
        this.userClaimsService = userClaimsService;
        this.operators = [];
        this.brands = [];
        this.topUpOperator = true;
        this.topUpBrand = false;
    }
    TopupPage.prototype.canActivate = function () {
        return this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewTopUp);
    };
    TopupPage.prototype.attached = function () {
        this.loadOperators();
    };
    TopupPage.prototype.loadOperators = function () {
        var _this = this;
        var request = new LookupValueRequest();
        request.lookupValueQuery = LookupValueQuery.operators;
        request.setOverrideMetaDataFiltering(OrderByEnum.NameASC);
        this.lookupService.getLookup(request).then(function (x) {
            _this.operators = x.values;
        });
    };
    TopupPage.prototype.onOperatorSelected = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var request;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.selectedOperator = event.detail.item;
                        this.selectedBrand = null;
                        this.brandCreditModel = null;
                        this.operatorCreditModel = null;
                        this.topUpAmount = null;
                        if (!this.selectedOperator)
                            return [2 /*return*/];
                        request = new LookupValueRequest();
                        request.lookupValueQuery = LookupValueQuery.brands;
                        request.setOverrideMetaDataFiltering(OrderByEnum.NameASC);
                        request.parameters = this.selectedOperator.id.toString();
                        this.lookupService.getLookup(request).then(function (x) {
                            _this.brands = x.values;
                        });
                        return [4 /*yield*/, this.loadOperatorCredit()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TopupPage.prototype.loadOperatorCredit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queriesClientService.getData("odata/OperatorCredits?$filter=operatorId eq ".concat(this.selectedOperator.id))];
                    case 1:
                        response = _a.sent();
                        this.operatorCreditModel = response.value[0];
                        return [2 /*return*/];
                }
            });
        });
    };
    TopupPage.prototype.onBrandSelected = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.selectedBrand = event.detail.item;
                        this.topUpAmount = null;
                        if (!this.selectedBrand)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.loadBrandCredit()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TopupPage.prototype.loadBrandCredit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queriesClientService.getData("odata/BrandCredits?$filter=brandId eq ".concat(this.selectedBrand.id))];
                    case 1:
                        response = _a.sent();
                        this.brandCreditModel = response.value[0];
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TopupPage.prototype, "activeCreditModel", {
        get: function () {
            return this.topUpBrand ? this.brandCreditModel : this.operatorCreditModel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopupPage.prototype, "canTopUp", {
        get: function () {
            if (!this.topUpAmount)
                return false;
            if (this.topUpBrand)
                return !!this.selectedBrand;
            return !!this.selectedOperator;
        },
        enumerable: false,
        configurable: true
    });
    TopupPage.prototype.topup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 8]);
                        if (!this.topUpBrand) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.brandClientService.topup(this.selectedBrand.id, this.topUpAmount)];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.loadBrandCredit()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, this.operatorClientService.topup(this.selectedOperator.id, this.topUpAmount)];
                    case 4:
                        _b.sent();
                        return [4 /*yield*/, this.loadOperatorCredit()];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        this.topUpAmount = null;
                        this.notificationService.show("Top-up", "Top-up successful", NotificationType.Success);
                        return [3 /*break*/, 8];
                    case 7:
                        _a = _b.sent();
                        this.notificationService.show("Top-up", "Top-up failed", NotificationType.Error);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    TopupPage.prototype.saveAlerts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var credit, emails, emailRegex_1, invalid, uow, changes, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        credit = this.activeCreditModel;
                        if (credit.alertEmail) {
                            emails = credit.alertEmail.split(',').map(function (e) { return e.trim(); }).filter(function (e) { return e.length > 0; });
                            emailRegex_1 = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            invalid = emails.filter(function (e) { return !emailRegex_1.test(e); });
                            if (invalid.length > 0) {
                                this.notificationService.show("Alerts", "Invalid email address(es): ".concat(invalid.join(', ')), NotificationType.Error);
                                return [2 /*return*/];
                            }
                            credit.alertEmail = emails.join(', ');
                        }
                        uow = function (value) { return ({ action: UnitOfWorkAction.Modified, value: value, oldValue: null }); };
                        changes = {
                            failOnInsufficientCredit: uow(credit.failOnInsufficientCredit),
                            firstInsufficientCreditAlertInEuro: uow(credit.firstAlert),
                            secondInsufficientCreditAlertInEuro: uow(credit.secondAlert),
                            insufficientCreditAlertEmail: uow(credit.alertEmail)
                        };
                        if (!this.topUpBrand) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.brandClientService.save({ id: this.selectedBrand.id, changes: changes })];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.operatorClientService.save({ id: this.selectedOperator.id, changes: changes })];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        this.notificationService.show("Alerts", "Alert settings saved successfully", NotificationType.Success);
                        return [3 /*break*/, 6];
                    case 5:
                        _a = _b.sent();
                        this.notificationService.show("Alerts", "Failed to save alert settings", NotificationType.Error);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TopupPage.prototype, "canSaveAlerts", {
        get: function () {
            return this.topUpBrand ? !!this.selectedBrand : !!this.selectedOperator;
        },
        enumerable: false,
        configurable: true
    });
    TopupPage = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService,
            I18N,
            LookupClientService,
            QueriesClientService,
            BrandClientService,
            OperatorClientService,
            TokenClient,
            UserClaimsService])
    ], TopupPage);
    return TopupPage;
}());
export { TopupPage };
